import { FC, ReactNode } from 'react';
import { ProCheckbox } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { CheckboxProps } from 'antd/lib/checkbox';

export interface BaseCheckboxProps extends CheckboxProps {
  checkboxText?: ReactNode;
  checkedChildren?: ReactNode;
  unCheckedChildren?: ReactNode;
}

export interface SimpleFormCheckboxProps extends BaseSimpleFormProps {
  checkboxProps?: BaseCheckboxProps;
}
const simpleFormCheckbox: FC<SimpleFormCheckboxProps> = props => {
  const { disabledRender, checkboxProps, form, ...restProps } = props;
  const handleRender = (val: any) => {
    if (disabledRender) return disabledRender;
    return val
      ? checkboxProps?.checkedChildren || '是'
      : checkboxProps?.unCheckedChildren || '否';
  };
  return (
    <SimpleFormItem {...restProps} valuePropName="checked">
      {checkboxProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={handleRender}
        />
      ) : (
        <ProCheckbox {...checkboxProps}>
          {checkboxProps?.checkboxText}
        </ProCheckbox>
      )}
    </SimpleFormItem>
  );
};

simpleFormCheckbox.displayName = SimpleFormItemEnum.SimpleFormCheckbox;

export default simpleFormCheckbox;
